module.exports = __webpack_public_path__ + "img/bamboo-crystal.e52f5e1b.png";